import React from 'react';
import './GovHeaderBar.css';
import LinkToolbar from './components/LinkToolbar/LinkToolbar';
import FontSizeToolbar from './components/FontSizeToolbar/FontSizeToolbar';
import LanguageToolbar from './components/LanguageToolbar/LanguageToolbar';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

const GovHeaderBar = (props) => {
  const { t } = useTranslation();

  return (
    <div className='ContainerHeaderBar'>

      <div className="GovHeaderBar">
        <Button
          icon={props.isDarkMode ? 'pi pi-moon' : 'pi pi-sun'}
          className={`BtnDarkMode ${props.isDarkMode ? 'dark' : 'light'
            }`}
          onClick={props.handleDarkModeToggle}
          tooltip={
            props.isDarkMode
              ? t('mapTheme.dark')
              : t('mapTheme.light')
          }
          tooltipOptions={{ position: 'bottom' }}
          raised
        />
        <LinkToolbar />
        {/* <FontSizeToolbar /> */ }
        <LanguageToolbar handleLanguageChange={props.handleLanguageChange} />
      </div>

    </div>

  );
};

export default GovHeaderBar;
